import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import type { ReactFCC } from '@bbkAdminUtils/utility-types';
import logo from '@bbkAdminImages/cbretention-logo.png';
import whiteLogo from '@bbkAdminImages/cbretention-white-logo.png';
import cbGrowthLogo from '@bbkAdminImages/growth-logo.png';

export const CBRetentionLogo: ReactFCC<{
  white?: boolean;
  className?: Argument;
}> = ({ white, className }) => (
  <img
    srcSet={`${white ? whiteLogo : logo} 2x`}
    className={cs(className ?? 'tw-w-full')}
    alt="Chargebee Retention"
  />
);

export const CBGrowthLogo: React.FC = () => (
  <img
    srcSet={`${cbGrowthLogo}`}
    className="tw-w-full"
    alt="Chargebee Growth"
  />
);

export const CBGrowthLogoSVG = (
  <svg
    width="176"
    height="42.308"
    viewBox="0 0 176 42.308"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m13.462 20.536 27.153-6.464V0H26.543zM0 20.308c0 1.674.19 3.308.609 4.867l12.853-4.639L.494 15.857C.19 17.304 0 18.785 0 20.308m4.791-13.12 8.671 13.349L17.456.19A20.3 20.3 0 0 0 4.789 7.187m8.673 13.349 27.153 6.465V41.11H26.543z"
      fill="#F30"
    />
    <path
      d="m4.791 33.883 8.671-13.347 3.994 20.345c-5.06-.684-9.507-3.27-12.665-6.998"
      fill="#F30"
    />
    <path
      d="M69.787 37.227q-1.188 0-2.437-.091-1.218-.091-2.285-.244v-3.534q1.097.122 2.346.213 1.249.122 2.346.122 2.041 0 3.29-.487 1.279-.487 1.858-1.554.609-1.036.609-2.65v-3.259l.914-2.071q-.091 2.285-.944 3.899a6.1 6.1 0 0 1-2.315 2.437q-1.462.822-3.381.822a7.45 7.45 0 0 1-3.107-.64 7.3 7.3 0 0 1-2.376-1.767 8.3 8.3 0 0 1-1.523-2.65 9.5 9.5 0 0 1-.548-3.259v-.64q0-1.736.548-3.229.579-1.523 1.614-2.65a7.1 7.1 0 0 1 2.467-1.736 8 8 0 0 1 3.168-.609q2.041 0 3.534.883 1.523.883 2.376 2.559t.944 4.112l-.731.122v-7.158h3.351v14.591q0 3.016-1.036 4.874t-3.198 2.711q-2.132.883-5.483.883m1.218-10.022q1.218 0 2.224-.548t1.614-1.584.609-2.498v-1.066q0-1.401-.64-2.376a3.9 3.9 0 0 0-1.614-1.462 4.74 4.74 0 0 0-2.193-.518q-1.34 0-2.376.64-1.005.609-1.584 1.736t-.579 2.681q0 1.523.579 2.65t1.584 1.736q1.036.609 2.376.609m13.117 3.503v-16.54h3.351v7.006h-.091q0-3.564 1.523-5.392t4.478-1.828h.609v3.686h-1.158q-2.132 0-3.32 1.158-1.158 1.127-1.158 3.29v8.621zm20.534.579q-2.193 0-3.869-.701a8.5 8.5 0 0 1-2.833-1.889 8.6 8.6 0 0 1-1.767-2.742 8.8 8.8 0 0 1-.579-3.168v-.64q0-1.706.609-3.229a8.6 8.6 0 0 1 1.797-2.742 8.1 8.1 0 0 1 2.863-1.889q1.675-.701 3.777-.701t3.777.701a7.95 7.95 0 0 1 2.833 1.889 7.95 7.95 0 0 1 1.797 2.742q.609 1.523.609 3.229v.64q0 1.645-.609 3.168a8.1 8.1 0 0 1-1.736 2.742 8.5 8.5 0 0 1-2.833 1.889q-1.675.701-3.838.701m0-3.625q1.554 0 2.62-.67 1.066-.701 1.614-1.858.548-1.188.548-2.681 0-1.523-.579-2.681a4.2 4.2 0 0 0-1.645-1.858q-1.066-.701-2.559-.701t-2.589.701q-1.066.67-1.645 1.858-.579 1.158-.579 2.681 0 1.493.548 2.681.579 1.158 1.645 1.858 1.066.67 2.62.67m18.033 3.046 3.138-15.992h4.874l3.623 15.992h-3.351l-3.681-15.9h1.767l-3.258 15.901zm-1.251 0-.029-3.473h3.381v3.473zm-1.706 0-4.501-16.54h4.112l4.293 16.541zm12.308 0v-3.473h3.38l-.03 3.473zm1.339 0 3.808-16.541h3.84l-3.99 16.541zm18.468.213q-2.285 0-3.777-.579a4.23 4.23 0 0 1-2.193-2.01q-.731-1.432-.731-3.838l.03-14.987h3.96l-.03 15.261q0 1.218.64 1.889.67.64 1.889.64h2.589v3.625zm-9.321-13.647v-3.106h11.697v3.107zm15.249 13.434V8.472h4.234v12.977h-.729q0-2.498.638-4.234.64-1.736 1.889-2.65 1.279-.914 3.229-.914h.184q2.831 0 4.295 1.95t1.462 5.666v9.443h-4.234v-9.839q0-1.584-.914-2.498-.885-.914-2.346-.914-1.554 0-2.53 1.036-.943 1.005-.944 2.65v9.565z"
      fill="#111827"
    />
  </svg>
);
